import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LoggedInGuard } from './guards/logged-in.guard';
import { ErrorPageComponent } from '@npm.chapps.com/chapps.common.angular.library';
import { LicenseComponent } from './modules/license/license.component';
import { AccountConfirmComponent } from './modules/account/account-confirm/account-confirm.component';
import { AccountAlreadyConfirmedComponent } from './modules/account/account-already-confirmed/account-already-confirmed.component';
import { AccountErrorComponent } from './modules/account/account-error/account-error.component';
import { AccountCreatedComponent } from './modules/account/account-created/account-created.component';
import { ForbiddenPageComponent } from './components/forbidden-page/forbidden-page.component';
import { OfflinePageComponent } from './modules/shared/components/offline-page/offline-page.component';
import { OfflineGuard } from './guards/offline.guard';


const routes: Routes = [
  { path: '', redirectTo: '/issues', pathMatch: 'full' },
  { path: '', loadChildren: () => import('@npm.chapps.com/chapps.common.angular.library').then(m => m.ChappsCommonAngularLibraryModule)},
  { path: 'offline-page', component: OfflinePageComponent },
  { path: 'error-page', component: ErrorPageComponent },
  {
    path: 'jobs',
    loadChildren: () => import('./modules/actions/actions.module').then(m => m.ActionsModule),
    canActivate: [OfflineGuard, LoggedInGuard]
  },
  {
    path: 'issues',
    loadChildren: () => import('./modules/issues/issues.module').then(m => m.IssuesModule),
    canActivate: [OfflineGuard, LoggedInGuard]
  },
  {
    path: 'intervention-teams',
    loadChildren: () => import('./modules/intervention-teams/intervention-teams.module').then(m => m.InterventionTeamsModule),
    canActivate: [OfflineGuard, LoggedInGuard]
  },
  {
    path: 'contacts',
    loadChildren: () => import('./modules/contacts/contacts.module').then(m => m.ContactsModule),
    canActivate: [OfflineGuard, LoggedInGuard],
  },
  {
    path: 'logins',
    loadChildren: () => import('./modules/accounts/accounts.module').then(m => m.AccountsModule),
    canActivate: [OfflineGuard, LoggedInGuard]
  },
  { path: 'license', component: LicenseComponent, canActivate: [OfflineGuard, LoggedInGuard] },
  { path: 'account-confirm/:culture/:confirmationCode', component: AccountConfirmComponent, canActivate: [OfflineGuard] },
  { path: 'account-confirm/:culture', redirectTo: '', canActivate: [OfflineGuard] },
  { path: 'account-already-confirmed', component: AccountAlreadyConfirmedComponent, canActivate: [OfflineGuard] },
  { path: 'account-error', component: AccountErrorComponent, canActivate: [OfflineGuard] },
  { path: 'account-created', component: AccountCreatedComponent, canActivate: [OfflineGuard] },
  { path: 'forbidden-page', component: ForbiddenPageComponent, canActivate: [OfflineGuard] },
  { path: '**', redirectTo: '/jobs/list' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
